module.exports = "pegasus_template/assets/graycircle-google.png";